import styles from './Tag.module.scss';
import { ReactNode, SyntheticEvent } from 'react';
import cn from 'classnames';
import { Theme } from '../../../enums';
import { Button, ButtonTone } from '../../buttons/Button/Button';

export type TagProps = {
    className?: string;
    theme?: Theme;
    remove?: (e: SyntheticEvent<unknown, MouseEvent>) => void;
    children?: ReactNode | ReactNode[];
};
export function Tag({ children, className, remove, theme }: TagProps) {
    return (
        <div className={cn(styles.tag, 'c-tag', theme, className)}>
            {children}
            {remove && (
                <Button
                    icon="plus"
                    tone={ButtonTone.Hoverable}
                    onClick={remove}
                    className={styles.closeButton}
                />
            )}
        </div>
    );
}
